// This file is auto-generated. Do not edit manually.

import { z } from "zod";


export const DeleteUsersSchema = z.object({
    emails: z.array(z.string().email()),
})

export type DeleteUsersType = z.infer<typeof DeleteUsersSchema>;